import { unpurry } from "@suse-o11y/unpurry";
import { ceil as ceil_ } from "remeda";

export const ceil = unpurry(ceil_, 2);
